var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 18.6667C21.333 19.7712 22.2285 20.6667 23.333 20.6667C24.4375 20.6667 25.333 19.7712 25.333 18.6667C25.333 17.5621 24.4375 16.6667 23.333 16.6667C22.2285 16.6667 21.333 17.5621 21.333 18.6667Z",
    stroke: "#31B867",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2 10.6667C25.2875 10.2359 25.3333 9.78997 25.3333 9.33334C25.3333 5.65145 22.3485 2.66667 18.6667 2.66667C14.9848 2.66667 12 5.65145 12 9.33334C12 9.78997 12.0459 10.2359 12.1334 10.6667",
    stroke: "#31B867",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33366 10.6576H21.3337C25.1049 10.6576 26.9905 10.6576 28.1621 11.8298C29.3337 13.0019 29.3337 14.8884 29.3337 18.6615V21.3295C29.3337 25.1025 29.3337 26.9891 28.1621 28.1612C26.9905 29.3333 25.1049 29.3333 21.3337 29.3333H13.3337C8.30534 29.3333 5.79119 29.3333 4.22909 27.7705C2.66699 26.2076 2.66699 23.6923 2.66699 18.6615V15.9936C2.66699 10.9628 2.66699 8.44744 4.22909 6.88458C5.48654 5.62653 7.3609 5.38118 10.667 5.33333H13.3337",
    stroke: "#31B867",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.cd00e7df85afdfe9b07d56f8e488f67d.svg";
export { ForwardRef as ReactComponent };